import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface appsettingState {
	isLoading: boolean;
	appSettingOrder: any;
	appSettingOrderDeliveryFee: any;
}

const initialState: appsettingState = {
	isLoading: false,
	appSettingOrder: [],
	appSettingOrderDeliveryFee: []
};

const appSettingSlice = createSlice({
	name: 'appSetting',
	initialState,
	reducers: {
		getAppSettingInit: state => {
			state.isLoading = true;
		},
		getAppSettingSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			// console.log(action.payload.data.settings);
			const data = action.payload.data;
			state.appSettingOrder = [...data.settings];
		},
		getAppSettingError: state => {
			state.isLoading = false;
		},
		updateAppSettingInit: state => {
			state.isLoading = true;
		},
		updateAppSettingSuccess: state => {
			state.isLoading = false;
		},
		updateAppSettingError: state => {
			state.isLoading = false;
		},





		getAppDeliveyfeeSettingInit: state => {
			state.isLoading = true;
		},
		getAppDeliveyfeeSettingSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			// console.log(action.payload.data.settings);
			const data = action.payload.data;
			state.appSettingOrderDeliveryFee = [...data.deliveryFees];
		},
		getAppDeliveyfeeSettingError: state => {
			state.isLoading = false;
		},
		updateAppDeliveyfeeSettingInit: state => {
			state.isLoading = true;
		},
		updateAppDeliveyfeeSettingSuccess: state => {
			state.isLoading = false;
		},
		updateAppDeliveyfeeSettingError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	getAppSettingInit,
	getAppSettingSuccess,
	getAppSettingError,
	updateAppSettingError,
	updateAppSettingInit,
	updateAppSettingSuccess,


	getAppDeliveyfeeSettingInit,
	getAppDeliveyfeeSettingSuccess,
	getAppDeliveyfeeSettingError,
	updateAppDeliveyfeeSettingError,
	updateAppDeliveyfeeSettingInit,
	updateAppDeliveyfeeSettingSuccess
} = appSettingSlice.actions;

export default appSettingSlice.reducer;
